<template>
  <ion-page>
    <CabeceraComponentBackSearch
      :pdv="pdv"
      :isIOS="isIOS"
      :titulo="`Dif. stock (${clasif})`"
      color="primary"
      previo="inventarios"
      v-model="filtro_busqueda"
      :debounceMs="500"
      placeholder="Buscar por SKU o marca"
      @search-change="onSearchChange"
      @search-start="onSearchStart"
    />

    <ion-header class="segment-header">
      <ion-toolbar color="primary" class="top segmento" style="padding: 0 5px 0 5px">
        <ion-segment v-model="segmentFiltro" mode="ios" color="primary" class="todas" @ionChange="aplicarSegmento">
          <ion-segment-button value="articulo">{{ 'ARTICULO' }}</ion-segment-button>
          <ion-segment-button value="marca">{{ 'MARCA' }}</ion-segment-button>
        </ion-segment>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <!-- FAB escáner (indicador) -->
      <ion-fab vertical="top" horizontal="start" slot="fixed">
        <ion-fab-button :key="`scan-activo:${blinker}`" :class="blinker ? 'activo' : 'inactivo'" @click="abrirModalEscaner">
          <i class="fas fa-solid fa-barcode-read muy-grande" :class="blinker ? 'blink' : 'not-blink'" :key="`ion-scan:${blinker}`"></i>
        </ion-fab-button>
      </ion-fab>

      <!-- FAB filtros por marca -->
      <ion-fab vertical="top" horizontal="end" slot="fixed">
        <ion-fab-button color="primary" @click="abrirModalDeFiltros" v-if="numSelectedItems === 0">
          <i class="fas fa-sharp fa-filter en-fab"></i>
        </ion-fab-button>
        <ion-fab-button color="danger" @click="abrirModalDeFiltros" v-else>
          <ion-badge id="num-selected-items" color="primary">{{ numSelectedItems }}</ion-badge>
          <i class="fas fa-sharp fa-filter en-fab icon-filter"></i>
        </ion-fab-button>
      </ion-fab>

      <ion-row class="ion-justify-content-center" v-if="isSearching">
        <ion-col size="48" class="ion-align-self-center">
          <ion-progress-bar type="indeterminate" color="primary"></ion-progress-bar>
        </ion-col>
      </ion-row>

      <div class="container-tablet">

        <div v-if="filtradas && filtradas.length > 0" class="pickings-counter-sticky">
          <ion-button expand="block" fill="outline" size="large" class="trigger_scan">
            <ion-title>
              <ion-text class="ion-text-wrap estrecho">
                <b>{{ filtradas.length }} {{ labelItems }}</b>
              </ion-text>
            </ion-title>
          </ion-button>
        </div>

        <ion-row class="spin ion-justify-content-center" v-if="!showme">
          <ion-col class="spin ion-align-self-center" size="48">
            <ion-spinner></ion-spinner>
          </ion-col>
        </ion-row>
          
        <ion-list v-if="showme" class="ion-no-padding" style="margin:0;">
          <ion-item v-for="it in visibles" :key="itemKey(it)">
            <ion-row style="width:100%">
              <ion-col :size="modo === 'marca' ? 12 : 18" class="ion-align-self-center">
                <a v-if="modo === 'articulo'" href="#" class="titulo sku-link" @click.prevent="abrirModalUbis(it)">
                  {{ tituloItem(it) }}
                  <ion-icon :icon="openOutline" class="ion-no-padding inline-icon"></ion-icon>
                </a>
                <p v-else class="titulo">{{ tituloItem(it) }}</p>
                <div class="lote oscuro">{{ it.nombre || '' }}</div>
                <div class="lote oscuro valor azul" v-if="modo === 'marca'">{{ (it.skus || []).length }} SKUs</div>
                <small class="valor azul" v-if="it.preuni">Precio U: <b>{{ it.preuni? this.$filters.sDecimal0(it.preuni || 0) + '€' : '' }}</b></small>
              </ion-col>
              <ion-col size="8" class="ion-text-center ion-align-self-center">
                <div class="etiqueta">ALM.</div>
                <div class="valor azul">{{ num(it.stoalm) }}</div>
                <div style="border-top: 1px solid #ccc; margin: 5px 15%; opacity: 0.5;"></div>
                <div class="lote oscuro" style="font-size: 0.85rem;">{{ this.$filters.sDecimal0(it.val_alm || 0) }}€</div>
              </ion-col>
              <ion-col size="8" class="ion-text-center ion-align-self-center">
                <div class="etiqueta">CONT.</div>
                <div class="valor azul">{{ num(it.stoman) }}</div>
                <div style="border-top: 1px solid #ccc; margin: 5px 15%; opacity: 0.5;"></div>
                <div class="lote oscuro" style="font-size: 0.85rem;">{{ this.$filters.sDecimal0(it.val_man || 0) }}€</div>
              </ion-col>
              <ion-col :size="modo === 'marca' ? 20 : 14" class="ion-align-self-center">
                <div class="ion-text-center etiqueta">DIFERENCIAS</div>
                <ion-row class="ion-align-items-center">
                  <ion-col size="16" class="ion-text-right ion-no-padding ion-no-margin">
                    <div class="lote oscuro">Uds:</div>
                  </ion-col>
                  <ion-col size="32" class="ion-text-right ion-no-padding ion-no-margin">
                    <div class="valor">
                      <span class="titulo" :class="getDifColor(it.dif_ud)">{{ this.$filters.Entero(it.dif_ud || 0) }}</span>
                    </div>
                  </ion-col>
                </ion-row>
                <ion-row class="ion-align-items-center">
                  <ion-col size="16" class="ion-text-right ion-no-padding ion-no-margin">
                    <div class="lote oscuro">€:</div>
                  </ion-col>
                  <ion-col size="32" class="ion-text-right ion-no-padding ion-no-margin">
                    <div class="valor">
                      <span class="titulo" :class="getDifColor(it.dif_eur)">{{ this.$filters.sDecimal0(it.dif_eur || 0) }}</span>
                    </div>
                  </ion-col>
                </ion-row>

              </ion-col>
            </ion-row>
          </ion-item>
          <ion-infinite-scroll threshold="100px" @ionInfinite="onIonInfinite" :disabled="!puedeCargarMas">
            <ion-infinite-scroll-content loading-spinner="bubbles" loading-text="Cargando más {{ labelItems.toLowerCase() }}..."></ion-infinite-scroll-content>
          </ion-infinite-scroll>
        </ion-list>
      </div>

      <div v-if="visibles && visibles.length === 0 && showme" style="display: flex; flex: 1 1 auto; height: 100%;" class="ion-justify-content-center">
        <div class="ion-align-self-center">
          <h2>Sin diferencias en este segmento</h2>
          <p>Sin diferencias para la fecha seleccionada o filtros aplicados.</p>
        </div>
      </div>
    </ion-content>

    <ion-footer>
      <ion-row class="ion-padding footer-row container-tablet">
        <ion-col size="14" class="ion-text-center">
          <div class="etiqueta chiquito">Stock Inicial €</div>
          <div class="valor azul chiquito">{{ this.$filters.sDecimal0(global_val_alm || 0) }}</div>
        </ion-col>
        <ion-col size="14" class="ion-text-center">
          <div class="etiqueta chiquito">Stock Contado €</div>
          <div class="valor azul chiquito">{{ this.$filters.sDecimal0(global_val_man || 0) }}</div>
        </ion-col>
        <ion-col size="12" class="ion-text-center">
          <div class="etiqueta chiquito">Dif. €</div>
          <div class="valor chiquito">
            <span :class="getDifColor(global_val_man - global_val_alm)">{{ this.$filters.sDecimal0((global_val_man - global_val_alm) || 0) }}</span>
          </div>
        </ion-col>
        <ion-col size="8" class="ion-text-center">
          <div class="etiqueta chiquito">Mat. Dif. %</div>
          <div class="valor azul chiquito">{{ this.$filters.sDecimal0(porcentajeDif || 0) }}</div>
        </ion-col>
      </ion-row>
    </ion-footer>
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue'
import CabeceraComponentBackSearch from '@/components/CabeceraComponentBackSearch.vue'
import eventBus from '@/event-bus'
import { openToast } from '@/utilities/services/alert-utilities'
import { modalController } from '@ionic/vue'
import AppScanModal from '@/components/scanner/AppScanModal.vue'
import ModalFiltros from '@/components/ModalFiltros.vue'
import { scanGenericStart, scanGenericStop } from '@/utilities/scanner/scan-generic'
import { barcodeSharp } from 'ionicons/icons'
import { openOutline } from 'ionicons/icons'

export default defineComponent({
  name: 'InventarioDiferenciasPage',
  components: { CabeceraComponentBackSearch },
  props: ['pdv', 'fecinv', 'clasif'],
  data () {
    return {
      isIOS: this.$route.meta.isIOS,
      ubiku_rol: this.$route.meta.racrol,
      showme: false,
      isSearching: false,
      segmentFiltro: 'articulo',
      filtro_busqueda: '',
      searchSpec: null,
      blinker: false,
      element_id: 'inventario-diferencias-scan',
      modo: 'articulo',
      datos: [],
      global_val_alm: 0,
      global_val_man: 0,
      global_count_total: 0,
      global_count_dif: 0,
      filtradas: [],
      visibles: [],
      batchSize: 30,
      filtros: [],
      numSelectedItems: 0,
      selectedBrands: [],
      barcodeSharp,
      openOutline
    }
  },
  async mounted () {
    this.$NoBackNavigator()
    eventBus().emitter.once('transicion', () => (this.showme = false))
    if (Number(this.ubiku_rol) < 10) {
      openToast('Solo visible para gerente')
      this.$router.replace({ name: 'inventarios_main' })
      return
    }
    await this.fetchDatos()
    await this.escaner_generico()
  },
  async unmounted () {
    await scanGenericStop(this.element_id)
  },
  methods: {
    async escaner_generico () {
      await scanGenericStart(this.element_id, 'inventario-diferencias')
      this.leerEventosGenericos()
    },
    async leerEventosGenericos () {
      eventBus().emitter.off(`lectura_generica:${this.element_id}`)
      eventBus().emitter.once(`lectura_generica:${this.element_id}`, async (texto) => {
        const input_scaner = String(texto || '').replace(/\?/g, '_').trim()
        this.filtro_busqueda = input_scaner
        this.onSearchChange({ raw: input_scaner, apply: (t) => String(t).toUpperCase().includes(input_scaner.toUpperCase()) })
        this.leerEventosGenericos()
      })
    },
    async abrirModalEscaner () {
      try {
        this.blinker = false
        const modal = await modalController.create({
          component: AppScanModal,
          componentProps: { titulo: 'Escanea un código', elementId: this.element_id }
        })
        await modal.present()
        const { data, role } = await modal.onWillDismiss()
        this.blinker = true
        if (role === 'confirm' && typeof data === 'string') {
          const input_scaner = String(data || '').replace(/\?/g, '_').trim()
          this.filtro_busqueda = input_scaner
          this.onSearchChange({ raw: input_scaner, apply: (t) => String(t).toUpperCase().includes(input_scaner.toUpperCase()) })
        }
      } catch (ex) {
        this.blinker = true
        openToast('No se pudo abrir el escáner')
        console.log(ex)
      }
    },
    async abrirModalUbis (it) {
      if (this.modo !== 'articulo') return
      try {
        this.$router.push({
          name: 'inventario_sku_ubicaciones',
          params: { pdv: this.pdv, fecinv: this.fecinv, clasif: this.clasif, sku: it.sku },
          query: { nombre: it.nombre }
        })
      } catch (ex) {
        openToast('No se pudo abrir las ubicaciones')
        console.log(ex)
      }
    },
    async fetchDatos () {
      try {
        const payload = { fecinv: this.fecinv, clasif: this.clasif, modo: this.modo, q: this.filtro_busqueda }
        const res = await this.$http.post(`/inventario_diferencias/${this.pdv}`, payload)
        const arr = Array.isArray(res.data) ? res.data : []
        if (arr.length > 0) {
          this.global_val_alm = Number(arr[0].g_val_alm || 0)
          this.global_val_man = Number(arr[0].g_val_man || 0)
          this.global_count_total = Number(arr[0].g_count_total || 0)
          this.global_count_dif = Number(arr[0].g_count_dif || 0)
        } else {
          this.global_val_alm = 0
          this.global_val_man = 0
          this.global_count_total = 0
          this.global_count_dif = 0
        }
        if (this.modo === 'marca') {
          this.datos = arr.map(x => ({
            marca: String(x.marca || ''),
            nombre: String(x.nombre || ''),
            stoalm: Number(x.stoalm || 0),
            stoman: Number(x.stoman || 0),
            dif_ud: Number(x.dif_ud || 0),
            dif_eur: Number(x.dif_eur || 0),
            val_alm: Number(x.val_alm || 0),
            val_man: Number(x.val_man || 0),
            skus: Array.isArray(x.lista_skus) ? x.lista_skus : []
          }))
        } else {
          this.datos = arr.map(x => ({
            sku: String(x.sku || ''),
            marca: String(x.marca || ''),
            nombre: String(x.nombre || ''),
            preuni: Number(x.preuni || 0),
            stoalm: Number(x.stoalm || 0),
            stoman: Number(x.stoman || 0),
            dif_ud: Number(x.dif_ud || 0),
            dif_eur: Number(x.dif_eur || 0),
            val_alm: Number(x.val_alm || 0),
            val_man: Number(x.val_man || 0)
          }))
        }
        this.generarFiltrosMarcas()
        this.aplicarFiltros(true)
        this.showme = true
        this.blinker = true
      } catch (ex) {
        openToast('Error recuperando diferencias')
        this.datos = []
        this.showme = true
      }
    },
    setModo (m) {
      if (this.modo === m) return
      this.modo = m
      this.segmentFiltro = m
      this.showme = false
      this.datos = []
      this.filtradas = []
      this.visibles = []
      this.fetchDatos()
    },
    aplicarSegmento () {
      const m = this.segmentFiltro
      this.modo = m
      this.showme = false
      this.datos = []
      this.filtradas = []
      this.visibles = []
      this.selectedBrands = []
      this.numSelectedItems = 0
      this.fetchDatos()
    },
    onSearchStart () { this.blinker = true },
    onSearchChange (spec) {
      this.searchSpec = spec
      this.isSearching = true
      this.aplicarFiltros(true)
      this.$nextTick(() => { this.isSearching = false })
    },
    aplicarFiltros (reiniciar = false) {
      const spec = this.searchSpec
      const textoItem = (it) => `${it.sku} ${it.marca} ${it.nombre}`
      const porTexto = (it) => {
        if (!spec || spec.isEmpty) return true
        const toks = Array.isArray(spec.tokens) && spec.tokens.length > 0 ? spec.tokens : [spec.norm || '']
        const esc = toks.map(t => String(t).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
        const re = new RegExp(esc.join('.*'), 'i')
        return re.test(textoItem(it))
      }
      const porMarca = (it) => {
        if (!Array.isArray(this.selectedBrands) || this.selectedBrands.length === 0) return true
        return this.selectedBrands.includes(String(it.marca || ''))
      }
      this.filtradas = (this.datos || []).filter(it => porTexto(it) && porMarca(it))
      if (reiniciar) {
        const inicial = Math.min(this.batchSize, this.filtradas.length)
        this.visibles = this.filtradas.slice(0, inicial)
      } else {
        const limite = Math.min(this.visibles.length, this.filtradas.length)
        this.visibles = this.filtradas.slice(0, limite)
      }
    },
    generarFiltrosMarcas () {
      const marcas = [...new Set((this.datos || []).map(x => String(x.marca || '')).filter(Boolean))]
      this.filtros = [
        { filterName: 'Marcas', items: marcas, filteredItems: marcas, selectedItems: this.selectedBrands.slice() }
      ]
      this.numSelectedItems = this.selectedBrands.length
    },
    async abrirModalDeFiltros () {
      try {
        this.generarFiltrosMarcas()
        const modal = await modalController.create({
          component: ModalFiltros,
          componentProps: {
            filters: this.filtros,
            datos: this.datos,
            datosFiltrados: this.filtradas,
            rutas: [],
            datosFiltradosConRuta: []
          }
        })
        await modal.present()
        const { data, role } = await modal.onWillDismiss()
        if (role === 'clean') {
          this.selectedBrands = []
          this.numSelectedItems = 0
          this.generarFiltrosMarcas()
          this.aplicarFiltros(true)
          return
        }
        if (role === 'confirm') {
          this.filtros = data[0]
          const marcaFiltro = (this.filtros || []).find(f => f.filterName === 'Marcas')
          this.selectedBrands = (marcaFiltro && Array.isArray(marcaFiltro.selectedItems)) ? marcaFiltro.selectedItems.slice() : []
          this.numSelectedItems = this.selectedBrands.length
          this.aplicarFiltros(true)
        }
      } catch (ex) {
        openToast('Error abriendo filtros')
        console.log(ex)
      }
    },
    async onIonInfinite (ev) {
      try {
        const current = this.visibles.length
        const siguiente = Math.min(current + this.batchSize, this.filtradas.length)
        if (siguiente <= current) {
          ev.target.disabled = true
        } else {
          this.visibles = this.filtradas.slice(0, siguiente)
        }
      } finally {
        ev.target.complete()
      }
    },
    num (n) { try { return Number(n || 0).toLocaleString('es-ES') } catch { return String(n || 0) } },
    eur (n) { try { return Number(n || 0).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }) } catch { return String(n || 0) } },
    getDifColor (valor) {
      const v = Number(valor ?? 0)
      if (v === 0) return 'primary'
      return v > 0 ? 'warning' : 'darkdanger'
    },
    itemKey (it) { return this.modo === 'marca' ? `marca:${String(it.marca || '')}` : `sku:${String(it.sku || '')}` },
    tituloItem (it) { return this.modo === 'marca' ? (it.marca || '') : (it.sku || '') }
  },
  computed: {
    labelItems () { return this.modo === 'marca' ? 'Marcas' : 'Artículos' },
    puedeCargarMas () {
      return this.visibles.length < this.filtradas.length
    },
    totales () {
      const base = this.filtradas || []
      return base.reduce((acc, r) => {
        acc.ud += r.dif_ud || 0
        acc.eur += r.dif_eur || 0
        acc.val_alm += r.val_alm || 0
        acc.val_man += r.val_man || 0
        return acc
      }, { ud: 0, eur: 0, val_alm: 0, val_man: 0 })
    },
    porcentajeDif () {
      if (this.global_count_total === 0) return 0
      return (this.global_count_dif / this.global_count_total) * 100
    }
  }
})
</script>

<style scoped>
.izquierda { text-align: left; }
.muy-grande { font-size: 1.4rem; }
.titulo { font-size: 1rem; font-weight: bold; margin: 0; }
.lote.oscuro { font-size: 0.9rem; color: var(--ion-color-medium); }
.lote.aviso { font-size: 0.9rem; color: var(--ion-color-warning); }
.lote.exito { font-size: 0.9rem; color: var(--ion-color-success); }
.lote.fracaso { font-size: 0.9rem; color: var(--ion-color-danger); }
ion-text.fake-titulo { color: var(--ion-color-primary) !important; }
.etiqueta { font-size: 0.8rem; color: var(--ion-color-medium); }
.valor { font-weight: bold; }
.azul { color: var(--ion-color-primary);  }
.rojo { color: var(--ion-color-danger); }
.darkdanger { color: var(--ion-color-danger) }
.success { color: var(--ion-color-success) }
.warning { color: var(--ion-color-warning) }
.primary { color: var(--ion-color-primary) }
.totales { position: sticky; bottom: 0; z-index: 12; }
.footer-row { width: 100%; padding: 10px 0; }
.blink { animation: blink 0.8s infinite; }
@keyframes blink { 0%{opacity:1} 50%{opacity:0.35} 100%{opacity:1} }
.pickings-counter-sticky {
  position: sticky;
  top: 0;
  z-index: 15;
  background-color: white;
  padding: 15px 70px;
  margin: 0;
  width: 100%;
}

.segment-header { position: sticky; top: 0; z-index: 9; }
ion-segment.todas {
  width: 100% !important; 
  margin-left: 6px !important;
  margin-right: 6px !important;
  padding: 3px 3px 16px 3px !important; 
}
ion-toolbar.segmento {
  height: 3rem !important; 
}
.in-segment-color {
  color: var(--ion-color-blanco) !important; 
}
.segment-button-checked {
  color: var(--ion-color-primary) !important; 
  font-weight: bold !important; 
}
.sku-link { text-decoration: none; color: black; }
.inline-icon { margin-left: 2px; margin: auto; vertical-align: middle; }
.container-tablet { width: 100%; max-width: 768px; margin: 0 auto; scrollbar-width: none; }
.chiquito { font-size: 0.9rem; }
.responsive-group { display: flex; flex-direction: column; height: 100%; justify-content: space-evenly; }
.metric-item { width: 100%; padding: 2px 0; }
@media (min-width: 768px) {
  .responsive-group { display: flex; flex-direction: row; }
  .metric-item { width: 50%; padding: 0; }
}
</style>
